import type { Component } from '@wix/thunderbolt-becky-types'
import { createCompNode } from '@wix/thunderbolt-catharsis'
import { EMPTY_ARRAY } from '../../../utils/constants'
import type { FeatureRefs } from '../../cssFeatures.types'

export const textMaskFontFamilies = {
	predicate: (component: Component) => component.componentType === 'TextMask',
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) =>
			refs.designQuery<{ family: string }>(component.designQuery!),
		toViewItem: (__, compDesign) => {
			return compDesign?.family ? [compDesign.family] : EMPTY_ARRAY
		},
	}),
}
